import request from '@/fetch/index'

// 知识产权接口

/**
 * 知识产权订单列表
 * @param pageNo
 * @param pageSize
 */
export function getZscqOrderList(params) {
  return request({
    url: '/api/loan/tripartite/intellectualProperty/applyList',
    method: 'GET',
    params
  })
}

/**
 * 知识产权获取订单详情
 * @param id 订单id
 */
export function getZscqOrderDetail(params) {
  return request({
    url: '/api/loan/tripartite/intellectualProperty/applyDetail',
    method: 'GET',
    params
  })
}

/**
 * 知识产权获取产品列表
 * @param pageNo
 * @param pageSize
 */
export function getZscqProductList(params) {
  return request({
    url: '/api/loan/tripartite/intellectualProperty/productList',
    method: 'GET',
    params
  })
}
